import { createContext } from 'react';
import { UIButtonVariant } from '../../ui-button';

export type UIConfirmationModalOpenData = {
    title: string;
    confirmText?: string;
    confirmVariant?: UIButtonVariant;
    cancelText?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    loading?: boolean;
};

export interface UIConfirmationModalContextData {
    isOpen: boolean;
    open: (data: UIConfirmationModalOpenData) => void;
    close: () => void;
    setLoading: (loading: boolean) => void;
}
export const UIConfirmationModalContext = createContext<
    UIConfirmationModalContextData | undefined
>(undefined);
